import { getApi } from "./util/getApi";

const fetchURL = process.env.REACT_APP_API_URL + "/memo";

const api = getApi(fetchURL);

export const getNotifications = async (dataPage: number) => {
  const res = await api.post("/retrieveAll", { dataPage: dataPage });
  return res.data;
};

export const updateNotificationStatus = async (id: number) => {
  const res = await api.post("/setMemoRead", { memoId: id });
  return res.data;
}